import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout do módulo Portfólio (Portal Vega, Bloco 1 — DEC-060). Só monta o <Outlet/>; abas filhas:
 * portfolio.index.tsx (Investimentos) e portfolio.tarefas.tsx. Caminho /portfolio preservado
 * (rota mais usada depois do board — não quebrar links salvos).
 */
export const Route = createFileRoute('/portfolio')({
  component: () => <Outlet />,
});
